
(function (global) {

  /**
  * Функции реализующие предпросмотр
  * @namespace Core.preview
  * @since 5.1.0.1523
  */
  global.preview = {};

  global.preview._checkDocumentType = function (accepted, extension) {
    if (WA.CR.Editor) {
      if (extension) {
        return (accepted.indexOf(extension) !== -1)
      } else {
        return (accepted.indexOf(WA.CR.Editor.Extension) !== -1)
      }
    } else {
      return false
    }
  }

  /**
  * Проверка того, что данный документ - документ для которого нужно включить прокрутку
  * @return {boolean}
  * @function Core.preview.isScrollableDocument
  * @since 5.1.0.1523
  * @global
  */
  global.preview.isScrollableDocument = function (opt_extension) {
    var accepted = ['PDF', 'TIF', 'TIFF', 'XPS', 'PPT', 'PPTX', 'PPTM', 'ODP'];
    return global.preview._checkDocumentType(accepted, opt_extension);
  };

  /**
  * Проверка того, что данный документ - текстовый.
  * @return {boolean}
  * @function Core.preview.isTextDocument
  * @since 5.2.0.1100
  * @global
  */
  global.preview.isTextDocument = function (opt_extension) {
    var accepted = ['DOC', 'DOCX', 'RTF', 'TXT', 'ODT'];
    return global.preview._checkDocumentType(accepted, opt_extension);
  };

  /**
  * Проверка того, что данный документ - таблица.
  * @return {boolean}
  * @function Core.preview.isSpreadSheet
  * @since 5.2.0.1100
  * @global
  */
  global.preview.isSpreadSheet = function (opt_extension) {
    var accepted = ['XLS', 'CSV', 'ODS'];
    return global.preview._checkDocumentType(accepted, opt_extension);
  }

  /**
  * Исправление запрета смешанного содержимого, когда ссылка http в iframe
  * блочится, пробрасываем её на родительский документ и открываем из него
  * @see #81595
  * @return {boolean}
  * @function Core.preview.fixHttpLinks
  * @since 5.2.0.1100
  * @global
  */
  global.preview.fixHttpLinks = function (data) {
    me = global;
    me._data = data || Core.preview.info;
    if (!me._data) return;
    var extension = me._data.objectsData[me._data.selectedObj.id].dataType;
    if (!global.preview.isSpreadSheet(extension)) return;

    var jIframe = $('iframe').contents();

    function getFrame(name) {
      return $(jIframe.find('frame[name=' + name + ']').get(0).contentWindow.document);
    }

    function rebindPassthrow() {
      getFrame('frSheet').find('a').unbind('click.pass').bind('click.pass', function () {
        window.open($(this).attr('href'));
        return false;
      })
    }

    getFrame('frTabs').find('a').bind('click.pass', function () {
      setTimeout(function () { rebindPassthrow(); }, 300);
    });
  },


  /**
  * Ограничение размеров текстовых документов страницей, и перемещение
  * комментариев рецензирования вправо.
  * @return {boolean}
  * @function Core.preview.isTextDocument
  * @since 5.2.0.1100
  * @global
  */
  global.preview.resizeTextDocuments = function (data) {
    me = global;
    me._data = data || Core.preview.info;
    if (!me._data) return;
    var extension = me._data.objectsData[me._data.selectedObj.id].dataType;
    if (!global.preview.isTextDocument(extension)) return;

    var jFrame = $('#contentContainer');
    var jDoc = jFrame.contents();

    if (extension === 'TXT') {
      jDoc.find('body')
        .wrapInner('<div class="WordSection1" id="txt"></div>');
    }

    jDoc.find('body').children('div')
      .wrapAll('<div id="centered"></div>')
      .wrapAll('<div id="leftColumn"></div>');

    var jCentered = jDoc.find('#centered');

    var isResized = false;
    jDoc.find('div[class*=WordSection]').each(function (el) {
      var jComments = $(this).find('.msocomanchor');

      if (jComments.length) {
        if (!jDoc.find('#review').length) {
          jCentered.append('<div id="review"></div>');
          jCentered.append('<div class="clear"></div>');
        }
        jCentered.css('width', '');
      } else {
        jCentered.css('width', '780px');
      }

      if (!$.ipad) {
        if ($(this).find('.MsoNormalTable').width() > $(this).width()) {
          //альбомная ориентация
          jCentered.css('width', '1613px');
          jDoc.find('#leftColumn').css('width', '1135px');
          $(this).css('width', '1135px');
          isResized = true;
        } else {
          if (isResized) {
            jCentered.css('width', '1613px');
            jDoc.find('#leftColumn').css('width', '1135px');
            $(this).css('width', '1135px');
          }
        }
      } else {
        if ($(this).find('.MsoNormalTable').width() > $(this).width()) {
          jCentered.css('width', '1630px');
          jDoc.find('#leftColumn').css('width', '1135px');
          $(this).css('width', '1135px');
          $(this).find('.MsoNormalTable').width('40%');
          isResized = true;
        }
        else {
          if (!isResized) {
            jCentered.css('width', '913px');
            jDoc.find('#leftColumn').css('width', '435px');
            $(this).css('width', '435px');
            isResized = true;
          } else {
            jCentered.css('width', '1630px');
            jDoc.find('#leftColumn').css('width', '1135px');
            $(this).css('width', '1135px');
          }
        }
      }

      //Ставим таймаут, чтобы для медленных браузеров отрисовка комментов не бежала впереди инициализации блока '#review'
      setTimeout(function () {
        if (jComments.length) {
          jComments.each(function (el) {
            var commentIdSelector = $(this).attr('href');
            var jComment = jDoc.find(commentIdSelector);
            var width = '300px';

            if ($.ipad) {
              width = '200px';
            }
            function bindHover(jEl) {
              jEl.hover(function () {
                jDoc.find('.hovered').removeClass('hovered');
                jComment.addClass('hovered');

                var commentAreaName = jComment.find('.comment-area').attr('href');
                if (commentAreaName)
                  commentAreaName = commentAreaName.substring(1);
                jDoc.find('a[name=' + commentAreaName + ']').addClass('hovered');
              });
            };

            bindHover($(this));

            jComment = jDoc.find(commentIdSelector).css({
              position: 'absolute',
              width: width,
              border: '1px solid #F66',
              color: '#333',
              padding: '10px',
              background: '#FCC',
              'text-align': 'left',
              '-webkit-backface-visibility': 'visible'
            });

            bindHover(jComment);
            bindHover(jDoc.find('a.comment-area[name=' + commentIdSelector.replace('#_cmnt', '_cmntref') + ']'));

            if ($.ipad) {
              setTimeout(function () {
                jDoc.find('a[href=' + commentIdSelector + ']').bind('click touchstart', function (e) {
                  jDoc.find('.hovered').removeClass('hovered');
                  jDoc.find(commentIdSelector).addClass('hovered');

                  var top = -(jDoc.find(commentIdSelector).offset().top - frames[0].window.prevScroll.y);
                  var left = -jDoc.find(commentIdSelector).offset().left;
                  frames[0].window.prevScroll.scrollTo(left, top);
                });
                jDoc.find(commentIdSelector).bind('click touchstart', function (e) {
                  jDoc.find('.hovered').removeClass('hovered');
                  $(this).addClass('hovered');
                });
              }, 200);
            }
          });
        };
        // Отступы для комментариев.
        global.preview.alignComments(jComments);
      }, 100);
    });
    
    // Высота не успевала рассчитываться, поэтому необходим таймут.
    setTimeout(function () {
      jDoc.find('#review').height(jCentered.height() - 47); // +20+25 margin +2 borders
    }, 101);

  };

  global.preview.alignComments = function (jComments) {
    var jFrame = $('#contentContainer');
    var jDoc = jFrame.contents();

    var jReviewControl = jDoc.find('#review');
    if (jReviewControl.length > 0) {
      var left = jReviewControl.offset().left;
      left += !$.ipad ? 15 : -25;
    }

    jComments.each(function () {
      var commentIdSelector = $(this).attr('href');
      var top = $(this).offset().top;

      jDoc.find(commentIdSelector).css({
        position: 'absolute',
        top: top,
        left: left + 'px'
      });
    });
  };

})(window.Core);

//При ресайзе окна комментарии съезжали влево
$(window).on('resize', function () {

  if ((WA.getLocation() == "doc") && ((new WA.URL(location.href)).getParam('view') == "Preview")) {
    var jFrame = $("#contentContainer");
    var jDoc = jFrame.contents();
    if (jDoc.find('#review').length > 0) {
      setTimeout(function () {
        if (jDoc.find('#review').length > 0) {
          var left = jDoc.find('#review').offset().left;
          if (!$.ipad) {
            left += 15;
          } else {
            left -= 25;
          }
          jDoc.find('div[class*=WordSection]').each(function (el) {
            var jComments = $(this).find('.msocomanchor');

            jComments.each(function (el) {
              var commentIdSelector = $(this).attr('href');
              jDoc.find(commentIdSelector).css({
                left: left + 'px'
              });
            });

          });
        }
      }, 200);
    }
  }
});


